import { useDeviceType } from '@cian/ui-kit';
import * as styles from './styles.css';
import { clsx } from 'clsx';
import { GifImage } from 'shared/components/GifImage';

interface ISliderStepProps {
  id: number;
  title: string;
  description: (string | string[])[];
  image?: string;
  imageUrl?: string;
  isActive?: boolean;
}

export const SliderStep: React.FC<ISliderStepProps> = ({
  id,
  title,
  description,
  image,
  imageUrl,
  isActive = false,
}) => {
  const device = useDeviceType();

  return (
    <div className={clsx(styles['container'], styles[device])}>
      <div className={styles['textblock']}>
        <div className={styles['step']}>0{id}</div>
        <div className={styles['title']}>{title}</div>
        <div className={styles['description']}>
          {description.map((elem, index) => {
            if (Array.isArray(elem)) {
              return (
                <div key={index}>
                  {elem.map((item, subindex) => (
                    <div key={subindex}>{item}</div>
                  ))}
                </div>
              );
            }

            return <div key={index}>{elem}</div>;
          })}
        </div>
      </div>
      {image && <div className={clsx(styles['image'], styles[image])} />}
      {imageUrl && <GifImage className={styles['image-url']} imageUrl={imageUrl} enabled={isActive} />}
    </div>
  );
};
